const transformString = (str) => {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z\s]/g, '')
    .replace(/\s+/g, '-');
};

const buildMenuTree = (menus, menuContents) => { 
  const menusByLanguage = {};
  
  menus.forEach(menu => {
    const lang = menu.languageCode === 'pt-br' ? 'pt' : menu.languageCode;
    menusByLanguage[lang] = menu.menuItems.nodes;
  });

  const languages = Object.keys(menusByLanguage);

  return menus.map(menu => {
    const language = menu.languageCode === 'pt-br' ? 'pt' : menu.languageCode;
    const map = {};
    const nodes = menu.menuItems.nodes;
    
    const menuContentsMap = menuContents
      .filter(content => content.languageCode === menu.languageCode)
      .reduce((acc, content) => {
        acc[content.name.toLowerCase()] = {
          logo: content.menuIcon?.logo?.node || null,
          description: content?.description || null,
        }; 
        return acc;
      }, {});

    const urlMap = {};

    nodes.forEach((node, index) => {
      const updatedNode = { ...node };

      const normalizedLabel = node.label.toLowerCase();
      const contentData = menuContentsMap[normalizedLabel];
      if (contentData) {
        updatedNode.logo = contentData.logo;
        updatedNode.description = contentData.description;
      } else {
        updatedNode.logo = null;
        updatedNode.description = null;
      }
      
      if (node.parentDatabaseId !== 0) {
        const parentLabel = nodes.find(item => node.parentDatabaseId === item.databaseId)?.label;
        const label = transformString(parentLabel);       
        updatedNode.url = updatedNode.url.search(/^http/) >= 0 ? updatedNode.url : `/${language}/${label}${updatedNode.url}`;
      } else {
        updatedNode.url = updatedNode.url ? `/${language}${updatedNode.url}` : '';
      }

      urlMap[node.databaseId] = updatedNode.url;

      updatedNode.translations = {};
      languages.forEach(lang => {
        const correspondingNode = menusByLanguage[lang]?.[index];
        if (correspondingNode) {        
          const correspondingParentNode = menusByLanguage[lang].find(
            item => item.databaseId === correspondingNode.parentDatabaseId
          );
          
          const correspondingParentSlug = correspondingParentNode
          ? transformString(correspondingParentNode.label)
          : '';

          if (correspondingParentNode) {
            updatedNode.translations[lang] = correspondingNode.url.search(/^http/) >= 0 ? correspondingNode.url : `/${lang}/${correspondingParentSlug}${correspondingNode.url}`;
          } else {
            updatedNode.translations[lang] = correspondingNode.url ? `/${lang}${correspondingNode.url}` : '';
          }
        }
      });

      map[updatedNode.databaseId] = { ...updatedNode, children: [] };
    });

    const tree = [];
    nodes.forEach(node => {
      if (node.parentDatabaseId === 0) {
        tree.push(map[node.databaseId]);
      } else {
        if (map[node.parentDatabaseId]) {
          map[node.parentDatabaseId].children.push(map[node.databaseId]);
        }
      }
    });
    return {
      [`${language}`]: tree,
    };
  });
};

export default buildMenuTree;
